 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		62: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		62: 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~me~24be5518","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~46fe826e","2":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~paint-reor~cf939e27","3":"browse-and-search~browse-and-search-mobile~collections~collections-mobile~overlay~paint-reorder~pain~7984b95f","4":"augmented-reality~promotion-products-lazy~quick-view~ratings-and-reviews~ratings-and-reviews-mobile~stylequiz","5":"buybox~fbr~fulfillment","6":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile","7":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","8":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","9":"bath-renovation~emt-generated-content","10":"media-gallery-filmstrip-mobile~media-gallery-overlay-mobile","11":"media-gallery-overlay~media-gallery-overlay-mobile","12":"ratings-and-reviews-mobile","13":"share-to-email-overlay~share-to-pinterest-overlay","14":"StoreLayout","15":"aisle-bay","16":"augmented-reality","17":"bath-renovation","18":"breadcrumbs","19":"browse-and-search","20":"browse-and-search-mobile","21":"buybox","22":"collection-list-component","23":"collections","24":"collections-mobile","25":"common","26":"compare","27":"consumer-card-messaging","28":"customer-image-overlay","29":"drawer","30":"emt-generated-content","31":"emt-links","32":"fbr","33":"fulfillment","34":"global-custom-configurator","35":"hammerjs","37":"home","38":"key-product-features","39":"measurement-guide","40":"measurement-guide-overlay-content","41":"media-gallery-filmstrip-mobile","42":"media-gallery-overlay","43":"media-gallery-overlay-mobile","44":"order-sample","45":"order-sample-drawer","46":"overlay","47":"paint-reorder","48":"paint-reorder-mobile","49":"pep","50":"pep-mobile","51":"product","52":"product-mobile","53":"product-overview","54":"promotion-products-lazy","55":"question","56":"questions-and-answers","57":"quick-view","58":"ratings-and-reviews","59":"ratings-and-reviews-desktop","60":"results","61":"returns-messaging","63":"share-to-email-overlay","64":"share-to-pinterest-overlay","65":"size-guide-overlay","66":"specifications","67":"stylequiz","68":"super-sku","69":"vendor-collection-products","70":"vendor-collections","71":"vendor-collections-mobile","73":"video-player","74":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"5ffd24a867b3758bfd0c","1":"9347b9b74bb0a50dbe15","2":"babc0994d90c19b769fb","3":"956ddd1caa26d2ba9fd7","4":"50ae30c66bde70dd381d","5":"830cb41959ff829e66b0","6":"3b9eb46980d5a6974e86","7":"97bbfa4fed7fa8730b3b","8":"6e993b727ca55dfd4c53","9":"6192402e92d357059b5d","10":"6e34a7659a167052bf33","11":"7cb5e8c1681c4b9d630d","12":"0ddecb30957374e766f7","13":"cd8a02440d308ae9f4de","14":"814ca4f4762806c9b05a","15":"399cf8cf1e34922828e7","16":"d785ba15b176778f9716","17":"09dc1f24b08f643ef433","18":"70253b154f9e240854e6","19":"5284e59f6b0f368a5f7c","20":"4f0e303e6fd9e1d5514f","21":"81b3031525595a902a55","22":"1f0712158f9463a496f8","23":"8f18a2ab1ecbb8c8eb8a","24":"cbc48e7808d233ad21f1","25":"19757e82a4058dc6d8fb","26":"d8f9d8cd596da181dc19","27":"411ff4a44bd6395533ec","28":"a7cce403936aa7e27243","29":"c65d076da17f639df483","30":"546207e789863d4649be","31":"c36471f199b8dde780c6","32":"94b07dd5f9f1b46e57d9","33":"bde92a8cc6685a3c6394","34":"2931b43382b360912b93","35":"0c33dcae97a87d887566","37":"97f3150231e5605bc78e","38":"ed4f2f80808afd886b4c","39":"c3165e08f3848bc8b6a7","40":"ca663d487714e4af1e0b","41":"a81fa957fdac80b3a929","42":"25527c1b976ae39cde62","43":"3d0ead062f529892477c","44":"d1f5ef9a5697266c77c1","45":"a1400b241955fd4d5b7e","46":"4d54adb4a7b54751e7ae","47":"7953bcd01fb57bc26c93","48":"62280de73d6896beb97b","49":"404a4b75fa866ff14ba3","50":"48be543936f48b805c9f","51":"89fcd6e6b2034704a62f","52":"83fbcd15200db17dd40b","53":"72740ab97c95c4b5d303","54":"f572cd4b16a1961ba85d","55":"0d09867930daddebc241","56":"d26b4d3f73515ac86f5b","57":"594fb3b7c27e2fdd8375","58":"5afd019d79776793539b","59":"cf2c74a159b2babcd182","60":"24633a3ad02b93dfac82","61":"3093b8c1dc802db3a481","63":"aa6b2edac44fbd6fffff","64":"0d8f8f8e7d1e4219bb98","65":"75b8fa6459b488f26324","66":"cc69e7d536d9ee0ea9d1","67":"d9277034736c9343b8ea","68":"7ea806fd16d160b00e3d","69":"b67df26ed5e5f926cccb","70":"0cca807b8d1d5b676789","71":"017e398bed3167216c39","73":"27ca62e71b2e014a1891","74":"e8a045520490a0b13bb0"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"1":1,"2":1,"3":1,"6":1,"7":1,"8":1,"9":1,"11":1,"12":1,"15":1,"16":1,"17":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"26":1,"27":1,"28":1,"29":1,"30":1,"32":1,"33":1,"34":1,"39":1,"40":1,"41":1,"42":1,"43":1,"46":1,"47":1,"48":1,"49":1,"50":1,"51":1,"52":1,"53":1,"54":1,"57":1,"58":1,"61":1,"65":1,"66":1,"67":1,"68":1,"70":1,"71":1,"74":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~me~24be5518","1":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~compare~pa~46fe826e","2":"bath-renovation~browse-and-search~browse-and-search-mobile~collections~collections-mobile~paint-reor~cf939e27","3":"browse-and-search~browse-and-search-mobile~collections~collections-mobile~overlay~paint-reorder~pain~7984b95f","4":"augmented-reality~promotion-products-lazy~quick-view~ratings-and-reviews~ratings-and-reviews-mobile~stylequiz","5":"buybox~fbr~fulfillment","6":"media-gallery-filmstrip-mobile~media-gallery-overlay~media-gallery-overlay-mobile","7":"ratings-and-reviews~ratings-and-reviews-desktop~ratings-and-reviews-mobile","8":"ratings-and-reviews~ratings-and-reviews-mobile~write-a-review-form","9":"bath-renovation~emt-generated-content","10":"media-gallery-filmstrip-mobile~media-gallery-overlay-mobile","11":"media-gallery-overlay~media-gallery-overlay-mobile","12":"ratings-and-reviews-mobile","13":"share-to-email-overlay~share-to-pinterest-overlay","14":"StoreLayout","15":"aisle-bay","16":"augmented-reality","17":"bath-renovation","18":"breadcrumbs","19":"browse-and-search","20":"browse-and-search-mobile","21":"buybox","22":"collection-list-component","23":"collections","24":"collections-mobile","25":"common","26":"compare","27":"consumer-card-messaging","28":"customer-image-overlay","29":"drawer","30":"emt-generated-content","31":"emt-links","32":"fbr","33":"fulfillment","34":"global-custom-configurator","35":"hammerjs","37":"home","38":"key-product-features","39":"measurement-guide","40":"measurement-guide-overlay-content","41":"media-gallery-filmstrip-mobile","42":"media-gallery-overlay","43":"media-gallery-overlay-mobile","44":"order-sample","45":"order-sample-drawer","46":"overlay","47":"paint-reorder","48":"paint-reorder-mobile","49":"pep","50":"pep-mobile","51":"product","52":"product-mobile","53":"product-overview","54":"promotion-products-lazy","55":"question","56":"questions-and-answers","57":"quick-view","58":"ratings-and-reviews","59":"ratings-and-reviews-desktop","60":"results","61":"returns-messaging","63":"share-to-email-overlay","64":"share-to-pinterest-overlay","65":"size-guide-overlay","66":"specifications","67":"stylequiz","68":"super-sku","69":"vendor-collection-products","70":"vendor-collections","71":"vendor-collections-mobile","73":"video-player","74":"write-a-review-form"}[chunkId]||chunkId) + "." + {"0":"83588448fb37280fe4ec","1":"1ddcea69157b3ceccb40","2":"9df49fd7932e64d85c32","3":"211b851d8b1f371f72c1","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"3aac127967b4748f441a","7":"b64df1f23a8d063c6e5f","8":"44bdc45463ae6045caed","9":"3ddf6831f9c83835f1ca","10":"31d6cfe0d16ae931b73c","11":"cd29c825359499f6a102","12":"b3f54d552e6de804d7d4","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"0c398782024b81c5a249","16":"360d23e52272197fbc71","17":"03ac34833d2e779bb027","18":"31d6cfe0d16ae931b73c","19":"2bef128b97f6c25f6f1d","20":"9d5e30bb06e676976dc0","21":"66125b7b851fc2dcc778","22":"addaa4823d823ea9cd7e","23":"7ab8e05cd253fd2c3d65","24":"d5e5fb247e7655b27b90","25":"31d6cfe0d16ae931b73c","26":"57bab727263f56ce6e27","27":"0a19be5d69b2fa3a2637","28":"f444d6a7096bb5ee9011","29":"ef3996406f012f6f3c69","30":"142724e93c83b9ea4c9b","31":"31d6cfe0d16ae931b73c","32":"0ef5871c0801693d996a","33":"101be70d609e618ebfcc","34":"1a5562a08d12f7682989","35":"31d6cfe0d16ae931b73c","37":"31d6cfe0d16ae931b73c","38":"31d6cfe0d16ae931b73c","39":"c686d5e31ff39005677d","40":"dbbbcf5ecdfa6bb35842","41":"5dda4f3f80579ea88758","42":"6c739317b2d45d476626","43":"58cf4120346e02f9d705","44":"31d6cfe0d16ae931b73c","45":"31d6cfe0d16ae931b73c","46":"0f0e9ffb1f3210fbd52e","47":"2579828c00329d0fd21f","48":"8bb42265c43c2dc1d63f","49":"8d4cf4b9136bdce245f9","50":"bb6342b935187832620b","51":"f6272036a2b7689684c5","52":"80f2772b96a16274ff1e","53":"52e4e2a91ab03f5bea7a","54":"44c2d1a3f6fed10dfaa1","55":"31d6cfe0d16ae931b73c","56":"31d6cfe0d16ae931b73c","57":"503de9a2a055c7dcd187","58":"90996f20c5fccb20353c","59":"31d6cfe0d16ae931b73c","60":"31d6cfe0d16ae931b73c","61":"a8c95bf9ef670117c76e","63":"31d6cfe0d16ae931b73c","64":"31d6cfe0d16ae931b73c","65":"790cbe42bd61998b1627","66":"756fbc6ffaa685c8fe11","67":"ec3ac19a92f20a31dfb0","68":"1aa1298dd39638c16bd8","69":"31d6cfe0d16ae931b73c","70":"5e9f51ecc1ce5a19d757","71":"5f1fd3f4a1b1fe5a5ffc","73":"31d6cfe0d16ae931b73c","74":"1a28d4bf12e36cf0dedf"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://assets.thdstatic.com/experiences/hd-home/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
